export default __webpack_public_path__ + "static/logo-3de-537a804588b2c866f198bf2b74378e6a.png";